import React, { useEffect, useState } from "react";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { Button, Modal, Radio, Table } from "antd";
import {
  ErrorToast,
  SuccessToast,
  UpdatedToast,
} from "../../../views/ToastComponent";

const ContructionContractor = ({ ProfileId, profileId }) => {
  const [allBusinessPd, setAllBusinessPd] = React.useState([]);
  const [areaType, setAreaType] = React.useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  const [EditDataId, setEditDataId] = React.useState(0);

  const [garageAutoData, setGarageAutoData] = React.useState({
    businessPdProfileId: profileId,
    latitude: "",
    longitude: "",
    siteAddress: "",
    buildupArea: 0,
    completionTime: 0,
    unskilledLabor: 0,
    skilledLabor: 0,
    wagesUnskilledLabor: 0,
    wagesSkilledLabor: 0,
    totalWages: 0,
    siteVisit: false,
    contractCost: 0,
    grossIncomeMonthly: 0,
    grossProfit: 0,
    grossIncome: 0,
    totalMaterialCost: 0,
    materialCost: 0,
  });

  // Single User

  const [constructinEditData, setconstructionEditdata] = useState({
    businessPdProfileId: profileId,
    profitMarginId: 0,
    siteAddress: "",
    buildupArea: 0,
    completionTime: 0,
    skilledLabor: 0,
    unskilledLabor: 0,
    wagesSkilledLabor: 0,
    wagesUnskilledLabor: 0,
    totalWages: 0,
    contractCost: 0,
    materialCost: 0,
    totalMaterialCost: 0,
    grossIncome: 0,
    grossIncomeMonthly: 0,
    grossProfit: 0,
    siteVisit: true,
    remarks: "",
    latitude: "",
    longitude: "",
  });

  //update Method

  const handleUpdate = async (id) => {
    try {
      const response = await axios.put(
        `${Api_Url}api/v1/Construction/${id}`,
        constructinEditData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response.data.succeeded) {
        handleCancel();
        fetchIncomeData()
      }
    } catch (error) {
      return error;
    }
  };

  const columns = [
    {
      title: "Area Type",
      dataIndex: "profitMarginName",
      // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
    },
    {
      title: "Site Address",
      dataIndex: "siteAddress",
      // sorter: (a, b) => a.siteAddress.length - b.siteAddress.length,
    },
    {
      title: "Build-Up Area",
      dataIndex: "buildupArea",
      // sorter: (a, b) => a.buildupArea.length - b.buildupArea.length,
    },
    {
      title: "Completion Time",
      dataIndex: "completionTime",
      // sorter: (a, b) => a.completionTime.length - b.completionTime.length,
    },
    {
      title: "Un-Skilled Labour",
      dataIndex: "unskilledLabor",
      // sorter: (a, b) => a.unskilledLabor.length - b.unskilledLabor.length,
    },
    {
      title: "Skilled Labour",
      dataIndex: "skilledLabor",
      // sorter: (a, b) => a.skilledLabor.length - b.skilledLabor.length,
    },
    {
      title: "Wages Un-Skilled",
      dataIndex: "wagesUnskilledLabor",
      // sorter: (a, b) => a.wagesUnskilledLabor.length - b.wagesUnskilledLabor.length,
    },
    {
      title: "Wages Skilled",
      dataIndex: "wagesSkilledLabor",
      // sorter: (a, b) => a.wagesSkilledLabor.length - b.wagesSkilledLabor.length,
    },
    {
      title: "Total Wages",
      dataIndex: "totalWages",
      // sorter: (a, b) => a.totalWages.length - b.totalWages.length,
    },
    {
      title: "Site Visit",
      dataIndex: "siteVisit",
      render: (text) => {
        return text == true ? "Yes" : "No";
      },
    },
    {
      title: "Contract Cose",
      dataIndex: "contractCost",
      // sorter: (a, b) => a.contractCost.length - b.contractCost.length,
    },
    {
      title: "Material Cost",
      dataIndex: "materialCost",
      // sorter: (a, b) => a.materialCost.length - b.materialCost.length,
    },
    {
      title: "Total Material Cost",
      dataIndex: "totalMaterialCost",
      // sorter: (a, b) => a.totalMaterialCost.length - b.totalMaterialCost.length,
    },
    {
      title: "Gross Income",
      dataIndex: "grossIncome",
      // sorter: (a, b) => a.grossIncome.length - b.grossIncome.length,
    },
    {
      title: "GP Margin",
      dataIndex: "grossProfit",
      // sorter: (a, b) => a.grossProfit.length - b.grossProfit.length,
    },
    {
      title: "Gross Monthly Income",
      dataIndex: "grossIncomeMonthly",
      // sorter: (a, b) => a.grossIncomeMonthly.length - b.grossIncomeMonthly.length,
    },
    {
      title: "Edit",
      dataIndex: "edit",
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => handleClick(record.id)}
            // onClick={() => handleEdit(record.key)}
            style={{ marginLeft: "10px" }}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
    // {
    //   title: 'Delete',
    //   dataIndex: 'delete',
    //   // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
    //   render: (text, record) => (
    //     <div>
    //       {text}
    //       <Button
    //        className='btn btn-danger'
    //         type="primary"
    //         // onClick={() => handleClick(record.id)}
    //         style={{ marginLeft: '10px' }}
    //       >
    //       <i class="fa-solid fa-trash"></i>
    //       </Button>
    //     </div>
    //   ),
    // },
  ];

  const fetchIncomeData = async () => {
    const { data } = await axios.get(
      Api_Url + "api/v1/Construction/getbybusinesspdprofileid/" + profileId,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
        },
      }
    );
    setAllBusinessPd(data);
  };

  const fetchAreaType = async () => {
    try {
      const { data } = await axios.get(
        Api_Url + "api/v1/ProfitMargin/getbyprofileid/" + ProfileId,
        {
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user"))?.accessToken,
          },
        }
      );
      setAreaType(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCurentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setGarageAutoData((prev) => ({
          ...prev,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
        }));
      });
    } else {
      return "Geolocation is not supported by this browser.";
    }
  };

  // Submitting the Data
  const handleSubmit = async (operationType) => {
    try {
      let response;
      if (operationType == "Submit") {
        response = await axios.post(
          Api_Url + "api/v1/Construction",
          garageAutoData,
          {
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user"))?.accessToken,
            },
          }
        );
        setGarageAutoData((prev) => ({
          ...prev,
          siteAddress: "",
          buildupArea: 0,
          completionTime: 0,
          unskilledLabor: 0,
          skilledLabor: 0,
          wagesUnskilledLabor: 0,
          wagesSkilledLabor: 0,
          totalWages: 0,
          siteVisit: false,
          contractCost: 0,
          grossIncomeMonthly: 0,
          grossProfit: 0,
          grossIncome: 0,
          totalMaterialCost: 0,
          materialCost: 0,
        }));
        if (response.data.succeeded) {
          SuccessToast("Created Successfully");
          handleCancel();
          fetchIncomeData();
        }
      } else {
        garageAutoData.id = EditDataId;
        response = await axios.put(
          Api_Url + "api/v1/Construction/" + EditDataId,
          garageAutoData,
          {
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user"))?.accessToken,
            },
          }
        );
        if (response.data.succeeded) {
          UpdatedToast("Updated Successfully");
          handleCancel();
          fetchIncomeData();
        }
      }
    } catch (error) {
      ErrorToast("Something went wrong");
      console.log(error);
    }
  };

  async function handleCancel() {
    setGarageAutoData({
      ...garageAutoData,
      siteAddress: "",
      buildupArea: 0,
      completionTime: 0,
      unskilledLabor: 0,
      skilledLabor: 0,
      wagesUnskilledLabor: 0,
      wagesSkilledLabor: 0,
      totalWages: 0,
      siteVisit: false,
      contractCost: 0,
      grossIncomeMonthly: 0,
      grossProfit: 0,
      grossIncome: 0,
      totalMaterialCost: 0,
      materialCost: 0,
      profitMarginId: 0,
    });
    setEditDataId(0);
    setIsModalOpen(false);
  }

  const handleClick = async (id) => {
    setEditDataId(id);
    setIsModalOpen(true);
  };

  async function LoadSingleCableOperator(hereId) {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Construction/${hereId}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setGarageAutoData({
        ...garageAutoData,
        siteAddress: response.data.data.siteAddress,
        buildupArea: response.data.data.buildupArea,
        completionTime: response.data.data.completionTime,
        unskilledLabor: response.data.data.unskilledLabor,
        skilledLabor: response.data.data.skilledLabor,
        wagesUnskilledLabor: response.data.data.wagesUnskilledLabor,
        wagesSkilledLabor: response.data.data.wagesSkilledLabor,
        contractCost: response.data.data.contractCost,
        materialCost: response.data.data.materialCost,
        completionTime: response.data.data.completionTime,
        siteVisit: response.data.data.siteVisit,
        totalWages: response.data.data.totalWages,
        totalMaterialCost: response.data.data.totalMaterialCost,
        grossIncome: response.data.data.grossIncome,
        grossProfit: response.data.data.grossProfit,
        profitMarginId: response.data.data.profitMarginId,
      });
    } catch (e) {
      console.log("Load Single Auto Driver", e.message);
    }
  }

  useEffect(() => {
    if (EditDataId !== 0) {
      LoadSingleCableOperator(EditDataId);
    }
  }, [EditDataId !== 0]);

  React.useEffect(() => {
    fetchIncomeData();
    fetchAreaType();
    fetchCurentLocation();
  }, []);

  React.useEffect(() => {
    const result =
      garageAutoData.completionTime *
        garageAutoData.unskilledLabor *
        garageAutoData.wagesUnskilledLabor +
        garageAutoData.completionTime *
          garageAutoData.skilledLabor *
          garageAutoData.wagesSkilledLabor || 0;
    setGarageAutoData((prev) => ({
      ...prev,
      totalWages: parseInt(result.toFixed(2)),
    }));
  }, [
    garageAutoData.completionTime,
    garageAutoData.unskilledLabor,
    garageAutoData.skilledLabor,
    garageAutoData.wagesUnskilledLabor,
    garageAutoData.wagesSkilledLabor,
  ]);

  React.useEffect(() => {
    const result =
      garageAutoData.buildupArea * garageAutoData.materialCost || 0;
    setGarageAutoData((prev) => ({
      ...prev,
      totalMaterialCost: parseInt(result.toFixed(2)),
    }));
  }, [garageAutoData.materialCost, garageAutoData.buildupArea]);

  React.useEffect(() => {
    const result =
      garageAutoData.buildupArea * garageAutoData.contractCost -
        garageAutoData.totalMaterialCost || 0;
    setGarageAutoData((prev) => ({
      ...prev,
      grossIncome: parseInt(result.toFixed(2)),
    }));
  }, [
    garageAutoData.contractCost,
    garageAutoData.buildupArea,
    garageAutoData.totalMaterialCost,
  ]);

  React.useEffect(() => {
    const result =
      ((garageAutoData.grossIncome - garageAutoData.totalWages) /
        garageAutoData.completionTime) *
        30 || 0;
    setGarageAutoData((prev) => ({
      ...prev,
      grossIncomeMonthly: parseInt(result.toFixed(2)),
    }));
  }, [
    garageAutoData.grossIncome,
    garageAutoData.totalWages,
    garageAutoData.completionTime,
  ]);

  React.useEffect(() => {
    const result =
      (garageAutoData.grossIncomeMonthly / garageAutoData.totalWages) * 100 ||
      0;
    setGarageAutoData((prev) => ({
      ...prev,
      grossProfit: parseInt(Math.round(result)),
    }));
  }, [garageAutoData.grossIncomeMonthly, garageAutoData.totalWages]);

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-between">
          <h3 className="mb-0">Construction Contractor</h3>
          <button
            className="btn btn-primary submit-btn"
            onClick={() => setIsModalOpen(true)}
          >
            Add Contractor
          </button>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12 mx-auto">
          <Table
            className="table-striped"
            style={{ overflowX: "auto" }}
            columns={columns}
            dataSource={allBusinessPd}
            rowKey={(record) => record.id}
          />
        </div>
      </div>

      {/* Garage Auto Form */}
      <Modal
        title={
          <h4>{EditDataId == 0 ? "Add" : "Edit"} Contruction Contractor</h4>
        }
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        // closable={false}
        onCancel={() => handleCancel()}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button
              key="Cancel"
              className="btn btn-danger submit-btn"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            ,
            <button
              key="submit"
              className="btn btn-primary submit-btn"
              type="submit"
              onClick={() => handleSubmit(EditDataId == 0 ? "Submit" : "Edit")}
            >
              {EditDataId == 0 ? "Submit" : "Update"}
            </button>
          </div>,
        ]}
        width={800}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: 'red' }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Select Area Type
                  </label>
                  <select
                    id="vehicleType"
                    className="custom-select-style"
                    value={garageAutoData.profitMarginId}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        profitMarginId: event.target.value,
                      })
                    }
                  >
                    <option value={0} selected>
                      Select Area Type
                    </option>
                    {areaType.length > 0 &&
                      areaType.map((area) => (
                        <option value={area.id}>{area.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Site Address
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Site Address"
                    value={garageAutoData.siteAddress}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        siteAddress: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Build-up Area
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Enter Build-up Area"
                    value={garageAutoData.buildupArea}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        buildupArea: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Completion Time (Day)
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Completion Time (Day)"
                    value={garageAutoData.completionTime}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        completionTime: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    No. of Unskilled Labor
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="No. of Unskilled Labor"
                    value={garageAutoData.unskilledLabor}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        unskilledLabor: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    No. of Skilled Labor
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder=" No. of Skilled Labor"
                    value={garageAutoData.skilledLabor}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        skilledLabor: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Wages-unskilled Labour
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Wages-unskilled Labour"
                    value={garageAutoData.wagesUnskilledLabor}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        wagesUnskilledLabor: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Wages-Skilled Labour
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Wages-Skilled Labour"
                    value={garageAutoData.wagesSkilledLabor}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        wagesSkilledLabor: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row my-3 mb-4">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Total Wages: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  &#8377; {garageAutoData.totalWages || "0.00"}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Contract cost per sqft
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder=" Contract cost per sqft"
                    value={garageAutoData.contractCost}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        contractCost: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Matetial cost per sqft
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Matetial cost per sqft"
                    value={garageAutoData.materialCost}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        materialCost: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row mt-3 my-2">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Total Material Cost: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  &#8377; {garageAutoData.totalMaterialCost || "0.00"}
                </span>
              </div>
            </div>

            <div className="row mt-3 my-2">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Gross Income: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  &#8377; {garageAutoData.grossIncome || "0.00"}
                </span>
              </div>
            </div>

            <div className="row mt-3 my-2">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Gross Income Monthly: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  &#8377; {garageAutoData.grossIncomeMonthly || "0.00"}
                </span>
              </div>
            </div>

            <div className="row mt-3 mb-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Gross Profit Margin: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  {garageAutoData.grossProfit + " %" || "0%"}
                </span>
              </div>
            </div>

            <div className="row mt-3 my-2">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Site Visited
                  </label>
                  <Radio.Group
                    className="form-control border-0"
                    value={garageAutoData.siteVisit}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        siteVisit: event.target.value,
                      })
                    }
                  >
                    <Radio value={true}>Yes</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      {/* Edit Modal */}

      <Modal
        title={<h4>Add Contruction Contractor</h4>}
        open={isEditModalOpen}
        onOk={() => setIsEditModalOpen(false)}
        // closable={false}
        onCancel={() => setIsEditModalOpen(false)}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button
              key="Cancel"
              className="btn btn-danger submit-btn"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            ,
            <button
              key="submit"
              className="btn btn-primary submit-btn"
              type="submit"
              onClick={() => handleUpdate(constructinEditData.id)}
            >
              Update
            </button>
            ,
          </div>,
        ]}
        width={800}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: 'red' }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Select Area Type
                  </label>
                  <select
                    id="vehicleType"
                    className="custom-select-style"
                    value={constructinEditData.profitMarginId}
                    onChange={(event) =>
                      setconstructionEditdata({
                        ...constructinEditData,
                        profitMarginId: event.target.value,
                      })
                    }
                  >
                    <option value={0} selected>
                      Select Area Type
                    </option>
                    {areaType.length > 0 &&
                      areaType.map((area) => (
                        <option value={area.id}>{area.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Site Address
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Site Address"
                    value={constructinEditData.siteAddress}
                    onChange={(event) =>
                      setconstructionEditdata({
                        ...constructinEditData,
                        siteAddress: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Build-up Area
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Enter Build-up Area"
                    value={constructinEditData.buildupArea}
                    onChange={(event) =>
                      setconstructionEditdata({
                        ...constructinEditData,
                        buildupArea: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Completion Time (Day)
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Completion Time (Day)"
                    value={constructinEditData.completionTime}
                    onChange={(event) =>
                      setconstructionEditdata({
                        ...constructinEditData,
                        completionTime: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    No. of Unskilled Labor
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="No. of Unskilled Labor"
                    value={constructinEditData.unskilledLabor}
                    onChange={(event) =>
                      setconstructionEditdata({
                        ...constructinEditData,
                        unskilledLabor: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    No. of Skilled Labor
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder=" No. of Skilled Labor"
                    value={constructinEditData.skilledLabor}
                    onChange={(event) =>
                      setconstructionEditdata({
                        ...constructinEditData,
                        skilledLabor: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Wages-unskilled Labour
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Wages-unskilled Labour"
                    value={constructinEditData.wagesUnskilledLabor}
                    onChange={(event) =>
                      setconstructionEditdata({
                        ...constructinEditData,
                        wagesUnskilledLabor: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Wages-Skilled Labour
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Wages-Skilled Labour"
                    value={constructinEditData.wagesSkilledLabor}
                    onChange={(event) =>
                      setconstructionEditdata({
                        ...constructinEditData,
                        wagesSkilledLabor: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row my-3 mb-4">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Total Wages: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  &#8377; {constructinEditData.totalWages || "0.00"}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Contract cost per sqft
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder=" Contract cost per sqft"
                    value={constructinEditData.contractCost}
                    onChange={(event) =>
                      setconstructionEditdata({
                        ...constructinEditData,
                        contractCost: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Matetial cost per sqft
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Matetial cost per sqft"
                    value={constructinEditData.materialCost}
                    onChange={(event) =>
                      setconstructionEditdata({
                        ...constructinEditData,
                        materialCost: parseInt(event.target.value),
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row mt-3 my-2">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Total Material Cost: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  &#8377; {constructinEditData.totalMaterialCost || "0.00"}
                </span>
              </div>
            </div>

            <div className="row mt-3 my-2">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Gross Income: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  &#8377; {constructinEditData.grossIncome || "0.00"}
                </span>
              </div>
            </div>

            <div className="row mt-3 my-2">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Gross Income Monthly: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  &#8377; {constructinEditData.grossIncomeMonthly || "0.00"}
                </span>
              </div>
            </div>

            <div className="row mt-3 mb-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Gross Profit Margin: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  {constructinEditData.grossProfit + " %" || "0%"}
                </span>
              </div>
            </div>

            <div className="row mt-3 my-2">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Site Visited
                  </label>
                  <Radio.Group
                    className="form-control border-0"
                    value={constructinEditData.siteVisit}
                    onChange={(event) =>
                      setconstructionEditdata({
                        ...constructinEditData,
                        siteVisit: event.target.value,
                      })
                    }
                  >
                    <Radio value={true}>Yes</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default ContructionContractor;
